import React from "react";
// import Chart from 'react-apexcharts'
import ApexCharts from "react-apexcharts";
import NotSubscribedMessageComponent from "./UI/NotSubscribedMessageComponent";

const UKCommunicationRecordAnalyticsComponent = () => {
  // const options = {
  //   chart: {
  //     id: 'basic-bar'
  //   },
  //   xaxis: {
  //     categories: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
  //   }
  // };

  // const series = [{
  //   name: 'series-1',
  //   data: [50, 44, 35, 48, 66, 89, 15]
  // }];

  return (
    <>
      <main className="middle_section dashboard_middle">
        <div className="container">
          <NotSubscribedMessageComponent />
        </div>
      </main>
    </>
  );
};

export default UKCommunicationRecordAnalyticsComponent;
